
import convertDecimalWithComma from "@/app/infrastructures/misc/common-library/ConvertDecimalWithComma";
import { ShipmentBookingDetail } from "@/domain/entities/ShipmentBooking";
import { Options, prop, Vue } from "vue-class-component";
import { formatByCountry, formatPhoneNumber } from "@/app/infrastructures/misc/Utils";

class Props {
  data = prop<ShipmentBookingDetail>({
    default: new ShipmentBookingDetail({}),
    type: ShipmentBookingDetail
  });
}
@Options({
  components: {}
})
export default class SectionDetailShipmentRecipient extends Vue.with(Props) {
  get formattedWeight() {
    return formatByCountry(Number(this.data.sttTotalChargeAbleWeight || 0), {
      type: "weight",
      suffix: " kg",
      country: this.data.sttBookedByCountry || undefined,
    });
  }

  convertDecimalWithComma(value: any) {
    return `${convertDecimalWithComma(value, 2)} kg`;
  }

  get phoneNumber() {
    return formatPhoneNumber(
      `${this.data.sttRecipientPhoneCode}${this.data.sttRecipientPhone}`
    ).replace("+", "");
  }

  get statusChipsStyle() {
    return {
      label: this.data.sttLastStatus?.toUpperCase(),
      color: "gray-lp-200",
      textColor: "black-lp-300"
    };
  }
}
